<template>
  <div class="container">
    <app-header :title="title" :is-back="isBack" @back="back"/>
    <van-search v-model="value" @click="$router.push('/search')" placeholder="请输入搜索关键词" />
    <!-- 分类 -->
    <div  style="overflow: hidden">
      <div class="tabs row">
        <div class="tab" v-text="item.name" v-for="(item,index) in tabList" :key="index" :class="[item.id == active?'active':'']" @click="handleTag(item,index)"></div>
      </div>
    </div>
    <Category :cateList="twoChild" v-if="twoChild.length > 0"/>

    <!-- 推荐商品 -->
    <Goods :productList="productList"/>

  </div>
</template>

<script>
  import Goods from './modules/Goods'
  import Category from './modules/Category'
  import { getShopCategoryList } from '@/api/category'
  import { getCategoryProductList } from '@/api/product'
  export default {
    name: 'Index',
    components: {
      Goods,
      Category
    },
    data() {
      return {
        isBack: false,
        title : '集成电路',
        value: '',
        tab: 0,
        active: 0,
        activeTag: 0,
        query: {
          id: 0,
          tab: 0,
          name: "",
          from: "",
          activeTag: 0
        },
        productList: [],
        tabList: [],
        twoChild: []
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        console.log('00000000000000000',from.query.from)
        if (from.query.from){
          vm.query.id = from.query.id
          vm.query.name = from.query.name
          vm.query.from = from.query.from
          vm.query.activeTag = from.query.activeTag

          vm.id = vm.$route.query.id
          vm.active = vm.$route.query.id
          vm.title = vm.$route.query.name
          vm.tab = vm.$route.query.tab
          vm.activeTag = vm.$route.query.activeTag
          vm.getTab(vm.activeTag);
        }
      })
    },
    beforeRouteLeave (to, from, next) {
      localStorage.setItem("scrollHomeCategory", document.documentElement.scrollTop)
      next()
    },
    activated:function() {
      this.$nextTick(() => {
        document.documentElement.scrollTop = localStorage.getItem("scrollHomeCategory")
        localStorage.setItem("scrollHomeCategory", 0)
      })
    },
    watch:{
      $route(){

      }
    },
    created() {

    },
    methods: {
      back(){
        this.$route.params.tab = this.tab
        this.$router.go(-1)

        // this.$router.push({
        //   path: '/homeTop',
        //   query:{
        //     ...this.query,
        //     tab: this.tab
        //   }
        // })
      },
      getTab(pid) {
        console.log("查询一级分类")
        getShopCategoryList({ pid: pid }).then(res => {
          if (res.success) {
            this.tabList = res.data
            if (this.tabList) {
              let temp = this.tabList[0]
              // if (temp) {
              //   this.active = temp.id
              // }
              this.getProduct(this.id)
            }
          }
        })
      },
      getSonTab(pid) {
        console.log("查询子分类")
        getShopCategoryList({ pid: pid }).then(res => {
          if (res.success) {
            this.twoChild = res.data
          }
        })
      },
      getProduct(cid) {
        getCategoryProductList({ parentId: cid }).then(res => {
          if (res.success) {
            this.productList = res.data
          }
        })
      },
      onNavigate(url) {
        this.$router.push({
          path: url
        })
      },
      handleTag(item,index) {
        this.active = item.id
        this.activeTag = item.id
        let pid = this.tabList[index].id
        this.getSonTab(pid)
        this.getProduct(this.activeTag)
        // this.getTab(this.activeTag);
      },
      gotoSearchProduct() {
        if (!this.value) {
          return
        }
        this.$router.push({
          path: '/searchProduct',
          query: {
            name: this.value
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .van-nav-bar__left img {
    width: 25px;
    height: 25px;
  }
  .container{

    .tabs{
      display: flex;
      flex-direction: row;
      align-items: center;
      height:44px;
      line-height: 44px;
      padding: 0 12px;
      overflow-x: scroll;
      -webkit-backface-visibility: hidden;
      -webkit-overflow-scrolling: touch;
      &::-webkit-scrollbar {
        display: none;
      }
      .tab {
        height:25px;
        line-height: 25px;
        padding: 0 0.4rem;
        white-space: nowrap;
        font-size: 16px;
        font-weight:bold;
        cursor: pointer;
        &.active {
          color: #FE003B;
          border-bottom: 3px solid #FE003B;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/goods/home_category.vue